export default __webpack_public_path__ + "static/media/GHSI Table of Attendance of Board of Directors.4c7370f1.pdf";